/**
 * External dependencies
 */
import { deburr } from 'lodash'; // @see packages/block-editor/src/components/inserter/search-items.js

export var normalizeInput = function normalizeInput(input) {
  return deburr(input).replace(/^\//, '').toLowerCase();
};
export var normalizedSearch = function normalizedSearch(title, search) {
  return -1 !== normalizeInput(title).indexOf(normalizeInput(search));
};
//# sourceMappingURL=utils.js.map